import { createContext } from "react";

export const AppContext: any = createContext({});
